"use strict";

var _defineProperty = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var yup = _interopRequireWildcard(require("yup"));
var _formik = require("formik");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _contactUsIcon = _interopRequireDefault(require("../assets/img/contactUsIcon"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _validation = require("./utils/validation");
var _helpers = require("./utils/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PhoneCall = (0, _helpers.getImageByAgent)('phone-call.svg');
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _beforeAfter;
  return {
    checkboxLabel: {
      '& a': {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 'normal',
        lineHeight: 1.2
      },
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'normal',
      lineHeight: 1.2,
      paddingTop: 8,
      textAlign: 'left'
    },
    contactUs: _defineProperty({
      backgroundColor: theme.palette.background.paper,
      borderColor: function borderColor(props) {
        return _helpers.agentDeveloperUtils.getSecondaryColor(props.typeOfTheme, 100);
      },
      color: theme.palette.secondary.main,
      fontSize: theme.typography.fontSize,
      fontWeight: 'bolder',
      width: 160
    }, theme.breakpoints.down(_breakpoints.default.mobile), {
      '&:hover': {
        color: _helpers.agentDeveloperUtils.getPrimaryColor(450)
      },
      fontSize: '.8rem',
      fontWeight: 600,
      height: 32,
      lineHeight: '0.9rem',
      padding: 0,
      width: 46
    }),
    formTitle: {
      color: theme.palette.secondary.main,
      fontSize: theme.typography.pxToRem(24.5),
      marginBottom: 30
    },
    img: {
      marginBottom: 10,
      width: 125
    },
    input: {
      '& .MuiFormHelperText-root ': {
        marginBottom: 5
      },
      fontSize: '14px',
      width: '100%'
    },
    thankYou: {
      '& img': {
        marginBottom: 20
      },
      alignItems: 'center',
      color: theme.palette.secondary.main,
      display: 'flex',
      flexDirection: 'column',
      fontSize: theme.typography.pxToRem(21),
      height: 320,
      justifyContent: 'center',
      lineHeight: 1.1,
      padding: 10,
      width: 236
    },
    tooltip: {
      '& .MuiTooltip-tooltip': {
        '&:before, &:after': (_beforeAfter = {
          borderWidth: 10,
          left: 'unset',
          right: 64
        }, _defineProperty(_beforeAfter, theme.breakpoints.down(_breakpoints.default.mobile), {
          right: 128
        }), _defineProperty(_beforeAfter, "transform", 'unset'), _beforeAfter),
        borderRadius: 15,
        padding: '18px 18px 22px 18px'
      },
      maxWidth: 274
    },
    touError: {
      margin: '0 14px'
    }
  };
});
var HeaderContactUs = function HeaderContactUs(_ref) {
  var open = _ref.open,
    isLoading = _ref.isLoading,
    handleClick = _ref.handleClick,
    handleClose = _ref.handleClose,
    handleSubmit = _ref.handleSubmit,
    contactWasSent = _ref.contactWasSent;
  var classes = useStyles();
  var isMobile = (0, _useMediaQuery.default)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    interactive: true,
    open: open,
    title: /*#__PURE__*/_react.default.createElement(ContactForm, {
      handleClose: handleClose,
      handleSubmit: handleSubmit,
      contactWasSent: contactWasSent
    }),
    placement: 'bottom',
    classes: {
      popper: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleClick,
    disabled: isLoading,
    variant: isMobile ? 'text' : 'outlined',
    color: "secondary",
    className: classes.contactUs,
    "aria-haspopup": "true",
    "aria-controls": "contactUs-form",
    "aria-expanded": open
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    size: 28
  }) : 'התקשרו אליי')));
};
HeaderContactUs.propTypes = {
  contactWasSent: _propTypes.default.bool,
  handleClick: _propTypes.default.func,
  handleClose: _propTypes.default.func,
  handleSubmit: _propTypes.default.func,
  isLoading: _propTypes.default.bool,
  open: _propTypes.default.bool
};
var ContactForm = function ContactForm(_ref2) {
  var handleClose = _ref2.handleClose,
    handleSubmit = _ref2.handleSubmit,
    contactWasSent = _ref2.contactWasSent;
  var classes = useStyles();
  var MainContainer = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.img
  }, /*#__PURE__*/_react.default.createElement(_contactUsIcon.default, {
    label: "24 7"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.formTitle
  }, "\u05EA\u05E0\u05D5 \u05DC\u05E0\u05D5 \u05DC\u05E2\u05D6\u05D5\u05E8!"), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    onSubmit: handleSubmit,
    validationSchema: yup.object().shape({
      fullname: _validation.hebrewOnly,
      phone: _validation.validPhone,
      tou: yup.boolean().oneOf([true], 'שדה חובה')
    }),
    initialValues: {
      fullname: '',
      phone: '',
      tou: false
    }
  }, function (_ref3) {
    var errors = _ref3.errors,
      touched = _ref3.touched,
      handleChange = _ref3.handleChange,
      handleBlur = _ref3.handleBlur,
      isSubmitting = _ref3.isSubmitting,
      values = _ref3.values;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, {
      "aria-label": "\u05D8\u05D5\u05E4\u05E1 \u05D4\u05E9\u05D0\u05E8\u05EA \u05E4\u05E8\u05D8\u05D9\u05DD \u05DC\u05D7\u05D6\u05E8\u05D4 \u05DE\u05E0\u05E6\u05D9\u05D2",
      id: "contactUs-form"
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: "contactUs-fullName",
      name: "fullname",
      label: 'שם מלא',
      onChange: handleChange,
      onBlur: handleBlur,
      error: errors.fullname && touched.fullname,
      className: classes.input,
      helperText: /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'fullname'
      })
    }), /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: "contactUs-phone",
      name: "phone",
      label: 'טלפון',
      onChange: handleChange,
      onBlur: handleBlur,
      className: classes.input,
      error: errors.phone && touched.phone,
      helperText: /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'phone'
      })
    }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      wrap: "nowrap"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      id: 'otp-tou',
      inputProps: {
        'aria-label': 'אני מאשר מאשרת את תנאי השימוש ומאשר מאשרת קבלת תוכן פרסומי כאמור בתנאים המפורטים'
      },
      onChange: handleChange,
      onBlur: handleBlur,
      name: "tou",
      checked: values.tou
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.checkboxLabel
    }, "\u05D0\u05E0\u05D9 \u05DE\u05D0\u05E9\u05E8/\u05EA \u05D0\u05EA \u05EA\u05E0\u05D0\u05D9 \u05D4\u05E9\u05D9\u05DE\u05D5\u05E9 \u05D5\u05DE\u05D0\u05E9\u05E8/\u05EA \u05E7\u05D1\u05DC\u05EA \u05EA\u05D5\u05DB\u05DF \u05E4\u05E8\u05E1\u05D5\u05DE\u05D9 \u05DB\u05D0\u05DE\u05D5\u05E8", /*#__PURE__*/_react.default.createElement("span", null, "\xA0"), /*#__PURE__*/_react.default.createElement(_core.Link, {
      href: _helpers.agentDeveloperUtils.getAgentLinks.termsAndConditions,
      target: "_blank"
    }, "\u05D1\u05EA\u05E0\u05D0\u05D9\u05DD \u05D4\u05DE\u05E4\u05D5\u05E8\u05D8\u05D9\u05DD")))), errors.tou && touched.tou ? /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
      error: true,
      className: classes.touError
    }, errors.tou) : ''), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      style: {
        display: 'flex',
        justifyContent: 'right'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.submitButton,
      variant: 'outlined',
      disabled: isSubmitting,
      type: 'submit',
      "aria-label": Object.keys(errors).length ? 'התקשרו אליי יש למלא תחילה את כל פרטי הטופס' : null
    }, "\u05D4\u05EA\u05E7\u05E9\u05E8\u05D5 \u05D0\u05DC\u05D9\u05D9")));
  }));
  var ThankYouContainer = /*#__PURE__*/_react.default.createElement("div", {
    className: classes.thankYou
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: PhoneCall,
    "aria-hidden": true,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("div", null, "\u05D1\u05E7\u05E9\u05EA\u05DA \u05E0\u05E9\u05DC\u05D7\u05D4!"), /*#__PURE__*/_react.default.createElement("div", null, "\u05E0\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DA \u05D1\u05D4\u05E7\u05D3\u05DD"));
  return /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: handleClose
  }, contactWasSent ? ThankYouContainer : MainContainer);
};
ContactForm.propTypes = {
  contactWasSent: _propTypes.default.bool,
  handleClose: _propTypes.default.func,
  handleSubmit: _propTypes.default.func
};
var _default = exports.default = HeaderContactUs;